import React, { useRef, useState, useEffect } from "react";
import SelectCountry, { components, NonceProvider } from "react-select";
import Select from "react-select";
const globePlaceholder = {
  label: "+Code",
  value: "+Code",
  languageCode: "+Code", // Used to show the globe icon
  isPlaceholder: true
};
const Level3AddUserModal = ({
  modalForLevel3AddUser,
  selectedLanguage,
  inputFields,
  handleChange,
  handleCodeChange,
  handleMobileChange,
  removeInputFields,
  addInputField,
  handlerModelCancelForLeve3AddUser,
  handlerModelConfirmLevel3ForAddUser,
  handleReceiptsAdding,
  countryCodeOptions,
  authType,
  handleAuthTypeChange,
  readerPrint,
  printEnabledType,
  defaultMaxPrintsPerReader,
  docLevelCanPrint

}) => {

  const rpdLevelOptions = authType.rpdLevelOptions || [];

  const rpdLevelValues = rpdLevelOptions.map((option) => option.value);

  const hasEmailOption = rpdLevelValues.includes("email");
  const hasTextOption = rpdLevelValues.includes("text");
  const endRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [position, setPosition] = useState(null);
  const handleMouseEnter = (e) => {
    const box = e.target.getBoundingClientRect();
    const { top, bottom, left, right } = box;
    const centerX = left + (right - left) / 2;
    const centerY = top + (bottom - top) / 2;
    const newPosition = centerY < window.innerHeight / 2 ? "bottom" : "top";
    setPosition(newPosition);
  };
  let VerificationOptions = [];
  if (hasEmailOption && hasTextOption) {
    VerificationOptions = [
      { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
      { value: "text", label: selectedLanguage.LstLanguageCodes.UI_Text },
      { value: "both", label: selectedLanguage.LstLanguageCodes.UI_Both },
    ];
  } else {
    if (hasEmailOption) {
      VerificationOptions.push({
        value: "email",
        label: selectedLanguage.LstLanguageCodes.UI_Email,
      });
    }
    if (hasTextOption) {
      VerificationOptions.push({
        value: "text",
        label: selectedLanguage.LstLanguageCodes.UI_Text,
      });
    }
  }

  const selectedVerificationOption = VerificationOptions.find(
    (option) => option?.value === authType?.verificationCode
  );
  const scrollIt = () => {
    setShouldScroll(true);
  }
  useEffect(() => {
    if (shouldScroll && endRef.current) {
      endRef.current.scrollIntoView({ behavior: "smooth" });
      setShouldScroll(false); // reset so it doesn’t scroll again
    }
  }, [inputFields, shouldScroll]);


  return (
    modalForLevel3AddUser && (
      <div className="modalCus" id="myModal" style={{ zIndex: 1056 }}>
        <div
          className="modal-dialog modal-dialog-centered modal-lg  max-width-popup"
          style={{ maxWidth: "1150px" }}>
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-center">
              <h4 className="mb-0 text-danger fw-bold font-20" htmlFor="">
                <img
                  src="assets/img/icons/authorize.png"
                  alt=""
                  className="h-30p me-2"></img>
                {selectedLanguage.LstLanguageCodes.UI_NewAutherizedReaders}
              </h4>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-2">
              <p className="font-16 ms-3 ps-1 mb-0 text-start ">
                {
                  selectedLanguage.LstLanguageCodes
                    .UI_ChangingAccessControlLimitReaders
                }
              </p>
              <div className="d-flex NewAuthBulBtn">
                <span
                  className="material-icons bulKUplodbtnNew"
                  onClick={() => handleReceiptsAdding()}
                  style={{ cursor: "pointer" }}>
                  file_upload
                </span>
                <span className="bulKUplodbtnNew" style={{ paddingTop: "1px" }}>
                  {selectedLanguage.LstLanguageCodes.UI_ImportReaderstooltip}
                </span>
              </div>
            </div>


            <div className="modal-body pb-0 ps-3 pe-3 res-px0">
              <div
                className=" authorizedReaders table-scrollbar max-width-popup"
                style={{
                  maxHeight: "250px",
                  overflow: "auto",
                  overflowX: "hidden",
                  display: "block",
                  paddingRight: "3px",
                }}>
                {inputFields.map((data, index) => {
                  return (
                    <div className="row d-flex align-items-center ps-1 mb-2">
                      {inputFields.length !== 1 ? (
                        <div className="col-11 col-sm-11 col-md-11 pe-0 " >
                          <div className="w-100" key={index}>
                            <div className="gap-12p d-flex align-items-center mobile-flow w-max-content" >
                              <div className="gridcol-22">
                                <input
                                  type="text"
                                  autoComplete="none"
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                  onBlur={(evnt) => handleChange(index, evnt)}
                                  value={data.email}
                                  name="email" title={data.email}
                                  className="form-control custom-inputBorder"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes.UI_Email
                                  }
                                />
                              </div>
                              <div className="gridcol-17 pe-0 gridcol-16">
                                <input
                                  // style={{ marginLeft: '-12px' }}
                                  type="text"
                                  autoComplete="none"
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                  value={data.firstName}
                                  name="firstName" title={data.firstName}
                                  className="form-control custom-inputBorder"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_FirstName
                                  }
                                />
                              </div>
                              <div className="gridcol-17 pe-0 gridcol-16">
                                <input
                                  //  style={{marginLeft:'-22px'}}
                                  type="text"
                                  autoComplete="none"
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                  value={data.lastName}
                                  name="lastName" title={data.lastName}
                                  className="form-control custom-inputBorder"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_LastName
                                  }
                                />
                              </div>
                            </div>
                            <div
                              style={{ marginTop: "9px" }}
                              className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                              <div className="gridcol-22">
                                <Select
                                  className="sendVerficationCodeBorder"
                                  options={VerificationOptions}
                                  value={selectedVerificationOption ?? VerificationOptions.find(option => option?.value?.toLowerCase() === data?.authType?.toLowerCase())}
                                  onChange={(event) => handleAuthTypeChange(event, index)}
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_SendVerificationCodeTo
                                  }
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  closeMenuOnScroll={() => true}
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      fontSize: "15px",
                                      width: "100%",
                                      minHeight: "40px",
                                      height: "40px",
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      height: "40px",
                                    }),
                                    indicatorsContainer: (provided) => ({
                                      ...provided,
                                      height: "40px",
                                    }),
                                    placeholder: (provided) => ({
                                      ...provided,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "center",
                                      width: "100%",
                                      cursor: "default",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                      // width: "233px",
                                      overflow: "hidden",
                                      // marginTop: '18px',
                                      maxHeight: "300px",
                                      overflowY: "auto",
                                      marginTop: "3px",
                                    }),
                                    menuPortal: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                      // width: "233px",
                                      //marginTop: '4px',
                                    }),
                                  }}
                                />
                              </div>
                              <div className="gridcol-25">
                                <div className="input-group custom-inputBorder">
                                  <span
                                    className="input-group-text mobile-group50"
                                    style={{ padding: "0px", width: '48%' }}>
                                    <SelectCountry
                                      value={data.mobileCountryCode?.value ? data.mobileCountryCode : globePlaceholder}
                                      placeholder="+Code"
                                      // placeholder={
                                      //   selectedLanguage.LstLanguageCodes
                                      //     .UI_CountryCode
                                      // }
                                      onChange={(event) =>
                                        handleCodeChange(event, index)
                                      }
                                      menuPosition="fixed"
                                      options={countryCodeOptions}
                                      styles={{
                                        control: (provided) => ({
                                          ...provided,
                                          display: "flex",
                                          fontSize: "15px",
                                          width: "100%",
                                          minHeight: "40px",
                                          height: '40px',
                                        }),
                                        valueContainer: (provided) => ({
                                          ...provided,
                                          height: "40px",
                                        }),
                                        indicatorsContainer: (provided) => ({
                                          ...provided,
                                          height: "40px",
                                        }),
                                        placeholder: (provided) => ({
                                          ...provided,
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          textAlign: "center",
                                          width: "100%",
                                          cursor: "default",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                          width: "233px",
                                          overflow: "hidden",
                                          // marginTop: '18px',
                                          maxHeight: "300px",
                                          overflowY: "auto",
                                        }),
                                        menuPortal: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                          width: "233px",
                                          //marginTop: '4px',
                                        }),
                                        indicatorSeparator: () => ({
                                          display: "none",
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                      getOptionLabel={(e) => `${e.label}`}
                                      getOptionValue={(e) => `${e.value}`}
                                      title="Select code"
                                      formatOptionLabel={(
                                        data,
                                        { context }
                                      ) => (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}>
                                          <div
                                            className={`${data.label === "+Code"
                                              ? "bg-  "
                                              : `bg-${data.languageCode}`
                                              }`}
                                            style={{
                                              width: "36px",
                                              height: "16px",
                                              marginRight: "8px",
                                            }}
                                          ></div>
                                          {context === "menu"
                                            ? `${data.label}`
                                            : `${data.value?.split("-")[0]}`}
                                        </div>
                                      )}
                                      noOptionsMessage={() => null}
                                    />
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control res-mobileinput"
                                    value={data.mobileNumber}
                                    maxLength={
                                      data.mobileCountryCode == undefined ||
                                        data.mobileCountryCode == null ||
                                        data.mobileCountryCode == "" ||
                                        data.mobileCountryCode == [] ||
                                        data.mobileCountryCode.value ==
                                        "+Code"
                                        ? 10
                                        : data.mobileCountryCode.mobileMaxLeng
                                    }
                                    onChange={(evnt) =>
                                      handleMobileChange(evnt, index)
                                    }
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_Mobile
                                    }
                                  />
                                </div>
                              </div>
                              <div className="gridcol-17 pe-0 gridcol-16">
                                <input
                                  type="text"
                                  //  disabled={securityLevl2}
                                  className="form-control custom-inputBorder"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_ReferenceTxt
                                  }
                                  value={data.reference} title={data.reference}
                                  name="reference"
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                />
                              </div>
                            </div>
                            <div className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                              <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
                                <div className={`checkbox mt-0 mb-0 d-flex align-items-center ${!docLevelCanPrint || printEnabledType === "everyone" ? "disabled" : ""}`} style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap" }}>
                                  <label className="ps-0 mb-0">
                                    <input
                                      type="checkbox"
                                      name="canPrint"
                                      checked={!docLevelCanPrint ? false : (printEnabledType === "everyone" ? true : data.canPrint)}
                                      disabled={!docLevelCanPrint || printEnabledType === "everyone"}
                                      onChange={(e) => handleChange(index, e)}
                                      id="txtPrint"
                                    />
                                    <span className="cr" tabIndex="42">
                                      <i className="cr-icon material-icons">check</i>
                                    </span>
                                    <span
                                      className={`toolltipModified  top`}
                                      onMouseEnter={handleMouseEnter}>
                                      {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                                    </span>
                                  </label>
                                </div>
                                <div className="d-flex flex-grow-1 align-items-center">
                                  <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                                    <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                                      {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                                    </span>
                                    <input
                                      type="text"
                                      placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                      className="control form-control h-47p border-Left"
                                      name="maxPrintsPerReader"
                                      value={
                                        data.maxPrintsPerReader !== undefined && data.maxPrintsPerReader !== null
                                          ? (data.maxPrintsPerReader !== 0 ? data.maxPrintsPerReader : "")
                                          : (defaultMaxPrintsPerReader !== 0 && defaultMaxPrintsPerReader !== null && defaultMaxPrintsPerReader !== undefined ? defaultMaxPrintsPerReader : "")
                                      }
                                      onChange={(e) => handleChange(index, e)}
                                      disabled={!docLevelCanPrint || (printEnabledType !== "everyone" && !data.canPrint)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className=" col-sm-12 col-md-12">
                          <div className="gap-12p d-flex align-items-center mobile-flow w-max-content" key={index} >
                            <div className="gridcol-22">
                              <input
                                className="form-control custom-inputBorder"
                                type="text"
                                autoComplete="none" title={data.email}
                                onChange={(evnt) =>
                                  handleChange(index, evnt)
                                }
                                onBlur={(evnt) => handleChange(index, evnt)}
                                value={data.email}
                                name="email"
                                placeholder={
                                  selectedLanguage.LstLanguageCodes.UI_Email
                                }
                              />
                            </div>
                            <div className="gridcol-17 pe-0 gridcol-16 res-16p">
                              <input
                                // style={{ marginLeft: '-12px' }}
                                className="form-control custom-inputBorder"
                                type="text"
                                autoComplete="none" title={data.firstName}
                                onChange={(evnt) =>
                                  handleChange(index, evnt)
                                }
                                value={data.firstName}
                                name="firstName"
                                placeholder={
                                  selectedLanguage.LstLanguageCodes
                                    .UI_FirstName
                                }
                              />
                            </div>
                            <div className="gridcol-17 pe-0 gridcol-16 res-16p">
                              <input
                                //  style={{marginLeft:'-22px'}}
                                className="form-control custom-inputBorder"
                                type="text"
                                autoComplete="none" title={data.lastName}
                                onChange={(evnt) =>
                                  handleChange(index, evnt)
                                }
                                value={data.lastName}
                                name="lastName"
                                placeholder={
                                  selectedLanguage.LstLanguageCodes
                                    .UI_LastName
                                }
                              />
                            </div>
                            {/* Country Code Dropdown and Mobile Number */}
                            {/* <div className="d-flex align-items-center res-w98"> */}
                          </div>
                          <div
                            style={{ marginTop: "9px" }}
                            className="gap-12p d-flex align-items-center mobile-flow w-max-content"
                            key={index}>
                            <div className="gridcol-22">
                              <Select
                                className="sendVerficationCodeBorder"
                                options={VerificationOptions}
                                value={selectedVerificationOption ?? VerificationOptions.find(option => option?.value?.toLowerCase() === data?.authType?.toLowerCase())}
                                onChange={(event) => handleAuthTypeChange(event, index)}
                                placeholder={
                                  selectedLanguage.LstLanguageCodes
                                    .UI_SendVerificationCodeTo
                                }
                                closeMenuOnScroll={() => true}
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    display: "flex",
                                    fontSize: "15px",
                                    width: "100%",
                                    minHeight: "40px",
                                    height: "40px",
                                  }),
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    height: "40px",
                                  }),
                                  indicatorsContainer: (provided) => ({
                                    ...provided,
                                    height: "40px",
                                  }),
                                  placeholder: (provided) => ({
                                    ...provided,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "center",
                                    width: "100%",
                                    cursor: "default",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                    // width: "233px",
                                    overflow: "hidden",
                                    // marginTop: '18px',
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                    marginTop: "3px",
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                    // width: "233px",
                                    //marginTop: '4px',
                                  }),
                                }}
                                menuPortalTarget={document.body}
                              />
                            </div>
                            <div className="gridcol-25">
                              <div className="input-group custom-inputBorder">
                                <span
                                  className="input-group-text mobile-group50"
                                  style={{ padding: "0px", width: '45%' }}>
                                  <SelectCountry
                                    value={data.mobileCountryCode?.value ? data.mobileCountryCode : globePlaceholder}
                                    onChange={(event) =>
                                      handleCodeChange(event, index)
                                    } // Pass index 0 to handle updates for the single reader
                                    options={countryCodeOptions}
                                    menuPosition="fixed"
                                    // placeholder="+Code"
                                    // menuIsOpen={false}
                                    // placeholder={
                                    //   selectedLanguage.LstLanguageCodes
                                    //     .UI_CountryCode
                                    // }
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        display: "flex",
                                        fontSize: "15px",
                                        width: "100%",
                                        minHeight: "40px",
                                        height: "40px",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        height: "40px",
                                      }),
                                      indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: "40px",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        textAlign: "center",
                                        width: "100%",
                                        cursor: "default",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        width: "233px",
                                        overflow: "hidden",
                                        // marginTop: '1px',
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                      }),
                                      menuPortal: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        width: "233px",
                                        //marginTop: '4px',
                                      }),
                                      indicatorSeparator: () => ({
                                        display: "none",
                                      }),
                                    }}
                                    menuPortalTarget={document.body}
                                    getOptionLabel={(e) => `${e.label}`}
                                    getOptionValue={(e) => `${e.value}`}
                                    title="Select code"
                                    formatOptionLabel={(
                                      data,
                                      { context }
                                    ) => (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}>
                                        <div
                                          className={`${data.label === "+Code"
                                            ? "bg-"
                                            : `bg-${data.languageCode}`
                                            }`}
                                          // className="bg-"
                                          style={{
                                            width: "36px",
                                            height: "16px",
                                            marginRight: "8px",
                                          }}
                                        ></div>
                                        {context === "menu"
                                          ? `${data.label}`
                                          : `${data.value?.split("-")[0]}`}
                                      </div>
                                    )}
                                    noOptionsMessage={() => null}
                                  />
                                </span>
                                <input
                                  type="text"
                                  className="form-control res-mobileinput res-mobileinputrightborder"
                                  value={data.mobileNumber}
                                  maxLength={
                                    data.mobileCountryCode == undefined ||
                                      data.mobileCountryCode == null ||
                                      data.mobileCountryCode == "" ||
                                      data.mobileCountryCode == [] ||
                                      data.mobileCountryCode.value ==
                                      "+Code"
                                      ? 10
                                      : data.mobileCountryCode.mobileMaxLeng
                                  }
                                  onChange={(evnt) =>
                                    handleMobileChange(evnt, index)
                                  }
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Mobile
                                  }
                                />
                              </div>
                            </div>
                            <div className="gridcol-17 pe-0 gridcol-16 res-16p">
                              <input
                                type="text"
                                className="form-control custom-inputBorder"
                                placeholder={
                                  selectedLanguage.LstLanguageCodes
                                    .UI_ReferenceTxt
                                }
                                name="reference" title={data.reference}
                                value={data.reference}
                                onChange={(evnt) =>
                                  handleChange(index, evnt)
                                }
                              />
                            </div>
                          </div>
                          <div className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                            <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
                              <div className={`checkbox mt-0 mb-0 d-flex align-items-center ${!docLevelCanPrint || printEnabledType === "everyone" ? "disabled" : ""}`} style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap" }}>
                                <label className="ps-0 mb-0">
                                  <input
                                    type="checkbox"
                                    name="canPrint"
                                    checked={!docLevelCanPrint ? false : (printEnabledType === "everyone" ? true : data.canPrint)}
                                    disabled={!docLevelCanPrint || printEnabledType === "everyone"}
                                    onChange={(e) => handleChange(index, e)}
                                    id="txtPrint"
                                  />
                                  <span className="cr" tabIndex="42">
                                    <i className="cr-icon material-icons">check</i>
                                  </span>
                                  <span
                                    className={`toolltipModified  top`}
                                    onMouseEnter={handleMouseEnter}>
                                    {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                                  </span>
                                </label>
                              </div>
                              <div className="d-flex flex-grow-1 align-items-center">
                                <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                                  <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                                    {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                                  </span>
                                  <input
                                    type="text"
                                    placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                    className="control form-control h-47p border-Left"
                                    name="maxPrintsPerReader"
                                    value={
                                      data.maxPrintsPerReader !== undefined && data.maxPrintsPerReader !== null
                                        ? (data.maxPrintsPerReader !== 0 ? data.maxPrintsPerReader : "")
                                        : (defaultMaxPrintsPerReader !== 0 && defaultMaxPrintsPerReader !== null && defaultMaxPrintsPerReader !== undefined ? defaultMaxPrintsPerReader : "")
                                    }
                                    onChange={(e) => handleChange(index, e)}
                                    disabled={!docLevelCanPrint || (printEnabledType !== "everyone" && !data.canPrint)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      )}
                      <div className="col-12 col-sm-12 col-md-1 res-mobilClose justify-content-end">
                        {inputFields.length !== 1 ? (
                          <button
                            className="btn btn-outline-danger d-flex res-px"
                            style={{
                              borderBottomColor: "#bc272e",
                              padding: "8px 10px",
                              verticalAlign: "middle",
                              position: "relative",
                              left: "10px"
                            }}
                            onClick={(e) => removeInputFields(index)}>
                            <span className="material-icons">backspace</span>
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })}
                <div ref={endRef} ></div>
              </div>
            </div>

            <div className="pb-4 px-3 d-flex flex-wrap justify-content-between">
              <button
                type="button"
                className="btn btn-outline-success px-2 mt-3 ms-1 add-reader truncate"
                data-bs-dismiss="modal"
                title={selectedLanguage.LstLanguageCodes.UI_AddReader}
                onClick={() => { addInputField(); scrollIt() }}>
                <span
                  className="material-icons me-2 font-20"
                  style={{ verticalAlign: "bottom" }}>
                  add_circle_outline{" "}
                </span>
                {selectedLanguage.LstLanguageCodes.UI_AddReader}
              </button>
              <div className="d-flex align-items-center mt-3">
                <button
                  type="button"
                  title={selectedLanguage.LstLanguageCodes.UI_Cancel}
                  className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                  data-bs-dismiss="modal"
                  onClick={(e) => handlerModelCancelForLeve3AddUser()}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  title={selectedLanguage.LstLanguageCodes.UI_Save}
                  className="btn btn-primary px-2 ms-1 w-140p truncate"
                  onClick={(e) => handlerModelConfirmLevel3ForAddUser()}>
                  {selectedLanguage.LstLanguageCodes.UI_Save}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Level3AddUserModal;
